import { render } from "./GroupSessions.vue?vue&type=template&id=12f98bd8"
import script from "./GroupSessions.vue?vue&type=script&lang=js"
export * from "./GroupSessions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__